// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { env } from '@/config/env';
import { getClerkSupabaseToken } from '@/lib/clerk-token';

const SUPABASE_URL = env.supabaseUrl;
const SUPABASE_PUBLISHABLE_KEY = env.supabaseKey;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Clerk is the sole auth engine (SSO Wave 3, REK-2166). The client
// authenticates every PostgREST / Functions / Realtime / Storage request with
// the Clerk session token via the `accessToken` closure (Supabase third-party
// auth). supabase.auth.* is forbidden — use helpers in src/lib/auth-bridge.ts.
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  accessToken: getClerkSupabaseToken,
});
